import React from 'react'

export const Download = ({ className = '', size = 12 }) => (
    <svg
        className={className}
        width={size}
        height={size}
        fill="#fff"
        viewBox="0 0 1000 1000"
        enableBackground="new 0 0 1000 1000"
        xmlSpace="preserve"
    >
        <path d="M924.3,700.4v222.3c0,37.3-30.2,67.4-67.4,67.4H143c-37.2,0-67.4-30.1-67.4-67.4V700.4c0-37.2,30.2-67.4,67.4-67.4c37.2,0,67.4,30.2,67.4,67.4v154.9h579.2V700.4c0-37.2,30.2-67.4,67.4-67.4C894.2,633,924.3,663.2,924.3,700.4z M452.4,758.1c13.2,13.2,30.4,19.7,47.6,19.7c17.3,0,34.5-6.6,47.7-19.7l202-202c26.4-26.3,26.4-68.9,0-95.2c-26.3-26.3-69-26.3-95.2,0l-87,87.1V77.4c0-37.2-30.1-67.4-67.4-67.4c-37.2,0-67.4,30.2-67.4,67.4v470.6l-87.1-87.1c-26.3-26.3-69-26.3-95.2,0c-26.3,26.3-26.3,69,0,95.2L452.4,758.1z" />
    </svg>
)

export const Code = ({ className = '', size = 14 }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 512 512"
        enableBackground="new 0 0 512 512"
        xmlSpace="preserve"
        fill="#fff"
    >
        <path d="M73.391,261.667l107.507-107.508c10.739-10.739,10.739-28.151,0-38.891c-10.739-10.74-28.151-10.739-38.891,0 L15.435,241.841c-5.469,5.468-8.146,12.667-8.045,19.833c-0.097,7.162,2.581,14.354,8.045,19.819l126.572,126.571 c10.738,10.739,28.151,10.739,38.891,0s10.739-28.151,0-38.891L73.391,261.667z" />
        <path d="M488.065,236.174L361.492,109.602c-10.739-10.739-28.151-10.74-38.891,0c-10.739,10.739-10.739,28.152,0,38.891L430.11,256 L322.602,363.508c-10.739,10.738-10.739,28.15,0,38.891c10.739,10.738,28.152,10.738,38.891,0l126.572-126.572 c5.467-5.467,8.144-12.662,8.045-19.826C496.208,248.836,493.531,241.64,488.065,236.174z" />
    </svg>
)
